//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import floraDistricts from '~/graphql/queries/floraDistricts.gql';
import {MATERIALS, SUN, MONITORING, LIME_CONTENT} from '~/plugins/constants';

export default {
  props: {
    thumbnail: {
      type: [Object, Array],
      default: null,
    },
  },
  data: () => ({
    thumbnailSource: null,
    floraDistricts: [],
    MATERIALS,
    SUN,
    MONITORING,
    LIME_CONTENT,
  }),
  watch: {
    thumbnail: {
      deep: true,
      handler() {
        this.changeThumbnail(this.thumbnail);
      },
    },
  },
  mounted() {
    if (this.thumbnail) {
      this.changeThumbnail(this.thumbnail);
    }

    this.$apollo.query({
      query: floraDistricts,
    }).then(({data}) => {
      this.floraDistricts = data.floraDistricts;
    });
  },
  methods: {
    changeThumbnail(img) {
      if (img.files) {
        this.thumbnailSource = window.URL.createObjectURL(img.files[0].file);
      } else if (img) {
        this.thumbnailSource = img.url;
      } else {
        this.thumbnailSource = null;
      }
    },
  },
};
